// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InstrumentSpecificType } from '@shared/utils/Instruments/InstrumentSpecificType';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { CurrentLang } from '@shared/localizations/Resources';
import { DataCache } from './DataCache';
import { SearchHelper } from './SearchHelper';
import { OptionType } from '@shared/utils/Instruments/OptionType';
export class TerceraSymbolLookupBaseDataProvider {
    getInstrumentsList(patern_1) {
        return __awaiter(this, arguments, void 0, function* (patern, exchangeIDs = null, instrumentTypes = null, generateStrikes = false, oldType = false) {
            if (!instrumentTypes) {
                instrumentTypes = [
                    InstrumentTypes.EQUITIES_CFD,
                    InstrumentTypes.FUTURES,
                    InstrumentTypes.FOREX,
                    InstrumentTypes.INDICIES,
                    InstrumentTypes.CRYPTO,
                    InstrumentTypes.SPREADBET,
                    InstrumentTypes.EQUITIES,
                    InstrumentTypes.CFD_FUTURES,
                    InstrumentTypes.FIXED_INCOME,
                    InstrumentTypes.ETF,
                    InstrumentTypes.TBILL,
                    InstrumentTypes.SPOT,
                    InstrumentTypes.OPTIONS,
                    InstrumentTypes.FORWARD,
                    InstrumentTypes.CORPORATE,
                    InstrumentTypes.FUND
                ];
            }
            if (instrumentTypes.includes(InstrumentTypes.EQUITIES_CFD) &&
                !instrumentTypes.includes(InstrumentTypes.CFD_FUTURES)) {
                instrumentTypes.push(InstrumentTypes.CFD_FUTURES);
            }
            const aliasLanguage = CurrentLang;
            return yield DataCache.GetInstrumentList(patern, exchangeIDs, instrumentTypes, generateStrikes, aliasLanguage, oldType).then(function (IInstrumentsList) {
                return IInstrumentsList;
            });
        });
    }
    getOptionsList(patern_1) {
        return __awaiter(this, arguments, void 0, function* (patern, exchangeIDs = null) {
            const aliasLanguage = CurrentLang;
            const optionsList = yield DataCache.GetOptionsList(patern, exchangeIDs, aliasLanguage);
            return optionsList;
        });
    }
    getInstrument(instrumentItem) {
        return __awaiter(this, void 0, void 0, function* () {
            if (instrumentItem.isHide) {
                return yield Promise.resolve(null);
            }
            let newIns = DataCache.getInstrumentByName(instrumentItem.GetInteriorID());
            const me = this;
            if (newIns) {
                return yield Promise.resolve(newIns);
            }
            else {
                // For ContinuousContract searching
                if (instrumentItem.Id &&
                    instrumentItem.InstrumentSpecificType === InstrumentSpecificType.ContinuousContract) {
                    // try fixedList
                    newIns = DataCache.getInstrumentByInstrumentIdAndRoute(instrumentItem.Id, instrumentItem.Route);
                    if (!newIns) // ok non fixedlist
                     {
                        return yield me.getContinuousInstrumentById(instrumentItem.Id, instrumentItem.Route);
                    }
                    return newIns;
                }
                else {
                    return yield me.getInstrumentByInstrumentTradableID_NFL(instrumentItem.InstrumentTradableID, instrumentItem.Route, instrumentItem.GetInteriorID());
                }
            }
        });
    }
    getOption(instrument) {
        return __awaiter(this, void 0, void 0, function* () {
            let newIns = DataCache.OptionsCache.getOptionFromCache(instrument);
            if (!isNullOrUndefined(newIns)) {
                return newIns;
            }
            yield DataCache.getOptionById(instrument.Id);
            if (instrument.optionType === OptionType.Fake) {
                newIns = DataCache.OptionsCache.getFirstOption(instrument);
            }
            else {
                newIns = DataCache.OptionsCache.getOptionFromCache(instrument);
            }
            return newIns;
        });
    }
    // TODO. Refactor.
    getInstrumentByName(instrumentName) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getInstrument(new SearchHelper(instrumentName));
        });
    }
    getContinuousInstrumentById(Id, Route) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield DataCache.getInstrumentById(Id).then(function (found) {
                if (found) {
                    return DataCache.getInstrumentByInstrumentIdAndRoute(Id, Route);
                }
                return null;
            });
        });
    }
    getInstrumentByInstrumentTradableID_NFL(InstrumentTradableID, Route, interiorID) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield DataCache.getInstrumentByInstrumentTradableID_NFL(InstrumentTradableID, Route, interiorID);
        });
    }
    getStrikesList(instrument) {
        if (instrument.ForwardBaseInstrument.isFuturesSymbol) {
            const underlierTradableId = instrument.ForwardBaseInstrument.InstrumentTradableID;
            return DataCache.GetInstrumentsByInstrumentIdRouteId(instrument.Id, instrument.Route).filter((ins) => ins.InstrType === InstrumentTypes.OPTIONS &&
                ins.ForwardBaseInstrument.InstrumentTradableID === underlierTradableId);
        }
        else {
            return DataCache.GetInstrumentsByInstrumentIdRouteId(instrument.Id, instrument.Route).filter((ins) => ins.InstrType === InstrumentTypes.OPTIONS);
        }
    }
    GetNonFixedInstrumentStrikes(instrument) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield DataCache.GetNonFixedInstrumentStrikes(instrument).then(function (IInstrumentsList) {
                return IInstrumentsList;
            });
        });
    }
    dispose() { }
}
